import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "forged_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, size) => {
    setItems((prev) => {
      const idx = prev.findIndex(
        (i) => i.product_id === product.id && i.size === size,
      );
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + 1 };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image: product.image,
          accent: product.accent,
          size,
          quantity: 1,
        },
      ];
    });
  };

  const updateQty = (product_id, size, qty) => {
    setItems((prev) =>
      prev
        .map((i) =>
          i.product_id === product_id && i.size === size
            ? { ...i, quantity: qty }
            : i,
        )
        .filter((i) => i.quantity > 0),
    );
  };

  const removeItem = (product_id, size) =>
    setItems((prev) =>
      prev.filter((i) => !(i.product_id === product_id && i.size === size)),
    );

  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
